import type { Session } from 'models/auth';

type SessionListener = (session: Session) => void;

const listeners = new Set<SessionListener>();

export function onSessionUpdated(listener: SessionListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitSessionUpdated(session: Session): void {
  listeners.forEach((listener) => {
    try {
      listener(session);
    } catch (err) {
      // Log and swallow errors from listeners to avoid breaking session update flow

      console.error('Error in session updated listener', err);
    }
  });
}
